module.exports = __webpack_public_path__ + "static/media/icon_chiropractor.87f1cf35.svg";